<template>
  <div class="report-check-general">
    <NavBar class="nav--bar" />
    <AuthBySessionExpired class="auth--by--session--expired" />
    <div class="container">
      <b-modal
        id="filter"
        size="md"
        no-close-on-backdrop
        hide-footer
        title="FILTRAR"
      >
        <div class="row">
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-center"
          >
            <label>FILTRAR POR RESIDENTES</label>
            <div class="d-flex align-items-center justify-content-center">
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_active"
                  @change="getResidents"
                  id="resident_active"
                />
                <label class="form-check-label" for="resident_active">
                  ATIVOS
                </label>
              </div>
              <div class="form-check m-1">
                <input
                  :disabled="loading"
                  class="form-check-input"
                  type="checkbox"
                  v-model="resident_not_active"
                  @change="getResidents"
                  id="resident_not_active"
                />
                <label class="form-check-label" for="resident_not_active">
                  INATIVOS
                </label>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <h6>SELECIONE O RESIDENTE</h6>
            <select
              v-model="resident_id"
              class="form-control"
              @input="handlePrescriptionsResident($event.target.value)"
            >
              <option
                v-for="resident in residents"
                :key="resident.id"
                :value="resident.id"
              >
                {{ String(resident.name).toUpperCase() }} -
                {{ String(resident.status_type_name).toUpperCase() }}
              </option>
            </select>
          </div>
          <div
            v-if="resident_id"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          >
            <h6>SELECIONE A PRESCRIÇÃO</h6>
            <div
              class="v-clean text-center p-2"
              v-if="group_prescription_medicines.length == 0"
            >
              RESIDENTE NÃO POSSUI PRESCRIÇÕES!
            </div>
            <b-overlay
              :show="loadingGroupPrescriptionMedicinesResident"
              opacity="0.99"
            >
              <select
                v-if="group_prescription_medicines.length > 0"
                v-model="group_prescription_medicine_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>
                <option
                  v-for="value in group_prescription_medicines"
                  :key="value.id"
                  :value="value.id"
                >
                  {{
                    `${formatDate(value.start_date, false)} - ${formatDate(
                      value.end_date,
                      false
                    )}`
                  }}
                  -
                  {{ handleTypeGroupPrescription(value.type) }}
                </option>
              </select>
            </b-overlay>
          </div>
          <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <h6 class="upper-text mt-3 mb-1">Data inicial</h6>
            <input type="date" v-model="dtInit" class="form-control" />
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <h6 class="upper-text mt-3 mb-1">Data final</h6>
            <input type="date" v-model="dtEnd" class="form-control" />
          </div> -->
          <div class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-sm-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn
              :disabled="loading"
              @click="paginate()"
              class="btn-filter"
              type="relief"
              ><i class="fas fa-filter mr-2 text-twenty"></i>

              {{ loading ? "CARREGANDO" : "FILTRAR" }}
            </v-btn>
          </div>
        </div>
      </b-modal>
      <div class="row filters">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-1"></i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">
            RELATÓRIO: CHECAGEM DOS MEDICAMENTOS - GERAL
          </h1>
        </div>
        <div
          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            @click="$bvModal.show('filter')"
            class="btn-filter mr-2"
            type="relief"
          >
            <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
          </v-btn>
          <v-btn
            :disabled="!group_prescription_medicine"
            @click="print"
            class="btn-print"
            type="relief"
          >
            <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR
          </v-btn>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean p-5 text-center"
          v-if="!group_prescription_medicine"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
          v-if="group_prescription_medicine"
        >
          <h6 class="mb-0 upper-text worksansr check-text-center">
            FILTRANDO:
            <span
              ><strong>{{ resident.name }}</strong> |
            </span>
            <span>
              PRESCRIÇÃO:
              <strong>
                {{
                  `${formatDate(
                    group_prescription_medicine.start_date,
                    false
                  )} - ${formatDate(
                    group_prescription_medicine.end_date,
                    false
                  )}`
                }}
                -
                {{
                  handleTypeGroupPrescription(group_prescription_medicine.type)
                }}
              </strong>
              |
            </span>
            <!-- <span
              ><strong>DATA INICIAL: {{ formatDate(dtInit, false) }} </strong>|
            </span>
            <span
              ><strong>DATA FINAL: {{ formatDate(dtEnd, false) }} </strong>|
            </span> -->
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <table
          class="table bg-white"
          v-if="resident.id && group_prescription_medicine"
        >
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 pb-0 pt-0"
                  >
                    <div class="row">
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-center text-center"
                      >
                        <img
                          v-if="rest_home_logo_url"
                          class="rest_home_logo_url"
                          :src="rest_home_logo_url"
                        />
                        <div v-if="!rest_home_logo_url" class="ml-1">
                          <strong class="text-uppercase">{{
                            rest_home_name
                          }}</strong>
                        </div>
                      </div>
                      <div
                        class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12 d-flex align-items-center"
                      >
                        <img
                          v-if="resident.photo_url"
                          class="resident_photo_url"
                          :src="resident.photo_url"
                        />
                        <img
                          v-if="!resident.photo_url"
                          class="resident_photo_url"
                          :src="require('../../../../assets/user.png')"
                        />
                        <div class="ml-3">
                          <h6 class="m-0">
                            {{ resident.name }}
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Data de nascimento:
                            {{ formatDate(resident.date_of_birth, false) }}
                            -
                            {{ getAge(resident.date_of_birth) }}
                            anos
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Data de admissão:
                            {{ formatDate(resident.date_of_reception, false) }}
                          </h6>
                          <h6
                            class="legends mb-1 worksansr"
                            v-if="resident.bed_id"
                          >
                            Leito Nº: {{ resident.bed_number }}, Andar:
                            {{ resident.bed_walk }}, ALA/Setor:
                            {{ resident.bed_ward_or_sector }}, Quarto:
                            {{ resident.bed_bedroom }}
                          </h6>
                          <h6 class="legends mb-1 worksansr">
                            Cadastrado:
                            {{ formatDate(resident.created_at, false) }}
                          </h6>
                        </div>
                      </div>
                      <div
                        class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 check-text-right"
                      >
                        <img class="logo" :src="logo" />
                      </div>
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center"
                      >
                        <h6 class="mb-1">
                          PRESCRIÇÃO:

                          {{
                            `${formatDate(
                              group_prescription_medicine.start_date,
                              false
                            )} - ${formatDate(
                              group_prescription_medicine.end_date,
                              false
                            )}`
                          }}
                          -
                          {{
                            handleTypeGroupPrescription(
                              group_prescription_medicine.type
                            )
                          }}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tr>
            <td>
              <div class="content">
                <div
                  v-for="(medicine, z) in group_prescription_medicine.medicines"
                  :key="z"
                  class="row border-bottom item"
                >
                  <div
                    class="col-md-6 d-flex flex-column justify-content-center"
                  >
                    <h6 class="m-0">{{ medicine.name }}</h6>
                    <p class="m-0 worksansr">
                      {{ medicine.active_ingredient }}
                    </p>
                    <div class="d-flex residenttop-content">
                      <h6
                        class="btn-pendent"
                        v-if="
                          medicine.type_of_recipe_name ==
                          'CONTROLE ESPECIAL - 2 VIAS'
                        "
                      >
                        CONTROLE ESPECIAL
                      </h6>
                    </div>
                    <h6
                      class="color-deleted text-thirteen check-text-center"
                      v-if="medicine.status == 'EXCLUIDO'"
                    >
                      MEDICAMENTO EXCLUIDO NO DIA
                      {{ formatDate(medicine.updated_at, false) }}.
                      <br />
                      <span>
                        NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                        {{ formatDate(medicine.end, false) }}!</span
                      >
                    </h6>
                    <h6
                      class="color-edit text-thirteen check-text-center"
                      v-if="medicine.edited == 1"
                    >
                      MEDICAMENTO EDITADO NO DIA
                      {{ formatDate(medicine.edited_date, false) }}.
                      <br />
                      <span class="color-deleted">
                        NÃO IRÁ APARECER NA PRESCRIÇÃO A PARTIR DO DIA
                        {{ formatDate(medicine.end, false) }}!
                      </span>
                    </h6>
                    <!-- --------- -->
                    <p
                      class="mb-0 worksansr legends"
                      v-if="
                        medicine.frequency != 'EVENTUAL' &&
                        (medicine.duration == 'ATE_A_DATA' ||
                          medicine.duration == 'DURANTE_UM_PERIODO')
                      "
                    >
                      Data de início:
                      {{ formatDate(medicine.start_date, false) }}
                    </p>
                    <p
                      class="mb-0 worksansr legends"
                      v-if="medicine.frequency != 'EVENTUAL'"
                    >
                      Duração:
                      {{ handleDuration(medicine.duration) }}
                    </p>
                    <p
                      class="mb-0 worksansr legends"
                      v-if="
                        medicine.frequency != 'EVENTUAL' &&
                        medicine.duration == 'DURANTE_UM_PERIODO'
                      "
                    >
                      Período de:
                      {{ medicine.duration_time }} dia(s)
                    </p>
                    <p
                      class="mb-0 worksansr legends"
                      v-if="
                        medicine.frequency != 'EVENTUAL' &&
                        medicine.duration == 'ATE_A_DATA'
                      "
                    >
                      Data de término:
                      {{ formatDate(medicine.end_date, false) }}
                    </p>
                    <!-- --------- -->
                    <p class="mt-0 mb-0" v-if="medicine.init">
                      Medicamento inicia:
                      {{ formatDate(medicine.init, false) }}
                    </p>
                    <p
                      class="mt-0 mb-0"
                      v-if="medicine.status == 'EXCLUIDO' && medicine.end"
                    >
                      Medicamento termina:
                      {{ formatDate(medicine.end, false) }}
                    </p>
                    <p
                      class="mt-0 mb-0"
                      v-if="medicine.edited == 1 && medicine.end"
                    >
                      Medicamento termina:
                      {{ formatDate(medicine.end, false) }}
                    </p>
                  </div>
                  <div class="col-md-6 d-flex align-items-center">
                    <div v-if="medicine.medicine_check.length == 0">
                      <p>NÃO FOI RETIRADO!</p>
                    </div>
                    <div
                      v-for="(medicine_check, index) in medicine.medicine_check"
                      :key="`${index}-${medicine.separate_stock_id}`"
                      class="row"
                    >
                      <div
                        class="col-md-12 d-flex flex-column justify-content-center"
                      >
                        <h6>
                          <span class="worksansr">TOTAL ADMINISTRADO:</span>
                          {{ medicine_check.total }}
                          {{ medicine.unit_of_measurement_abbreviation }}
                        </h6>
                        <h6>
                          <span class="worksansr">TOTAL NÃO ADMINISTRADO:</span>
                          {{ medicine_check.despised }}
                          {{ medicine.unit_of_measurement_abbreviation }}
                        </h6>
                        <p class="worksansr m-0">ESTOQUE QUE FOI RETIRADO:</p>
                        <p class="m-0">
                          {{ medicine_check.stock.stock_adjustment_name }} -
                          {{ medicine_check.stock.stock_adjustment_stock_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center">
                  <hr class="border-black m-0" />
                  (Assinatura eletrônica)
                  {{
                    professionalClassCouncilValue({
                      id: user.professional_class_council_id,
                      name: user.name,
                      profile: user.profile_name,
                      cpf: user.cpf,
                      office: user.office,
                      value: user.professional_class_council_value,
                    })
                  }}
                  <small>
                    - {{ moment().format("DD/MM/YYYY HH:mm:ss") }}
                  </small>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import api from "../../../../services/api";

import routes from "../../../../routes";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../lib/format";

import { getAge } from "../../../../lib/getAgeByDate";

import AuthBySessionExpired from "../../../Components/AuthBySessionExpired";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import NavBar from "../../../NavBar";

import { userData } from "../../../../lib/functions";

import moment from "moment";

export default {
  name: "ReportsMedicineCheck",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },
  data() {
    return {
      resident_active: true,
      resident_not_active: false,
      group_prescription_medicine: false,
      group_prescription_medicines: [],
      user: {},
      resident: {},
      residents: [],
      resident_id: "",
      group_prescription_medicine_id: "",
      dtInit: "",
      dtEnd: "",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
      loadingGroupPrescriptionMedicinesResident: false,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    professionalClassCouncilValue,
    handleTypeGroupPrescription(type) {
      if (type == "LONGO_PRAZO") {
        return "LONGO PRAZO";
      }

      return "NORMAL";
    },
    handleDuration(duration) {
      let durations = {
        CONTINUO: "CONTÍNUO",
        DURANTE_UM_PERIODO: "DURANTE UM PERÍODO",
        ATE_A_DATA: "ATÉ A DATA",
        default: "EVENTUAL",
      };

      return durations[duration] || durations.default;
    },
    async retrieve() {
      const { user, logo } = userData();

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      await this.getResidents();

      let { modal } = this.$router.currentRoute.query;

      if (modal) {
        this.$bvModal.show("filter");
      }
    },
    async getResidents() {
      try {
        let { resident_active, resident_not_active } = this;

        let status = "ATIVO";

        if (resident_active && resident_not_active) {
          status = "ALL";
        } else if (!resident_active && resident_not_active) {
          status = "INATIVO";
        } else if (!resident_active && !resident_not_active) {
          this.errors = [
            {
              id: this.errors.length,
              message: "Informe residentes ativos, inativos ou ambos",
            },
          ];
          this.residents = [];
          return;
        }

        let params = { status };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.residents = residents;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handlePrescriptionsResident(resident_id) {
      if (resident_id) {
        try {
          this.loadingGroupPrescriptionMedicinesResident = true;

          let params = { resident_id };

          const response = await api.get(
            "/rest-home/resident/group-prescriptions",
            {
              params,
            }
          );

          const { error, errors, group_prescription_medicines } = response.data;

          if (error) {
            this.errors = errors;
          } else {
            this.group_prescription_medicines = group_prescription_medicines;
          }

          this.loadingGroupPrescriptionMedicinesResident = false;
        } catch (error) {
          console.log(error);
        }
      }
    },
    async paginate() {
      try {
        this.loading = true;

        const { resident_id, group_prescription_medicine_id, dtInit, dtEnd } =
          this;

        var params = {
          resident_id,
          group_prescription_medicine_id,
          dtInit,
          dtEnd,
        };

        const response = await api.get("/rest-home/report/check/filter", {
          params,
        });

        const { group_prescription_medicine, resident, error, errors } =
          response.data;

        if (error) {
          this.group_prescription_medicine = false;
          this.errors = errors;
        } else {
          this.group_prescription_medicine = group_prescription_medicine;
          this.resident = resident;
          this.errors = [];
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    print() {
      window.print();
      routes;
      // let route = this.$router.resolve({
      //   name: "report_stock",
      //   params: {},
      // });

      // window.open(route.href, "_blank");
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.report-check-general .logo {
  height: 50px;
  object-fit: contain;
}
.report-check-general table {
  width: 100%;
}
.report-check-general .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.report-check-general .resident_photo_url {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  object-fit: cover;
}
@media print {
  .report-check-general .table {
    page-break-after: always !important;
  }
  .report-check-general .item {
    page-break-inside: avoid !important;
  }
  .report-check-general .nav--bar {
    display: none;
  }
  .report-check-general .auth--by--session--expired {
    display: none;
  }
  .report-check-general .filters {
    display: none;
  }
  .report-check-general button {
    display: none;
  }
}
</style>
